import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Sticky from 'react-stickynode'
import { withRouter } from 'react-router-dom'
import {
  CX,
  POPOVER_PROFILE_OPTIONS,
  PLACEHOLDER_MISSING_HEADER_SRC,
  MODAL_EDIT_PROFILE,
  BREAKPOINT_EXTRA_SMALL,
  BREAKPOINT_MEDIUM,
  BREAKPOINT_LARGE,
  MODAL_GIFT_GAB_PRO,
} from '../constants'
import {
  fetchRelationships,
} from '../actions/accounts'
import {
  addShortcut,
  removeShortcut,
} from '../actions/shortcuts'
import { createChatConversation } from '../actions/chat_conversations'
import { openModal } from '../actions/modal'
import { openPopover } from '../actions/popover'
import { me } from '../initial_state'
import AccountActionButton from './account_action_button'
import Avatar from './avatar'
import Button from './button'
import DisplayName from './display_name'
import Image from './image'
import TabBar from './tab_bar'
import Pills from './pills'
import Text from './text'
import ProfileHeaderXSPlaceholder from './placeholder/profile_header_xs_placeholder'
import ProfileNavigationBar from './navigation_bar/profile_navigation_bar'

const getBaseColor = (theme) => {
  if (theme === 'black') return '20,23,27'
  else if (theme === 'muted') return '34,34,34'
  else if (theme === 'night') return '35,38,54'
  return '255,255,255'
}

const giftIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" className={_s.inheritFill}>
    <path d="M19.5 7.75H18.1C18.5 7.27 18.75 6.67 18.75 6C18.75 4.48 17.52 3.25 16 3.25C14.32 3.25 12.84 4.14 12 5.46C11.16 4.14 9.68 3.25 8 3.25C6.48 3.25 5.25 4.48 5.25 6C5.25 6.67 5.5 7.27 5.9 7.75H4.5C3.81 7.75 3.25 8.31 3.25 9V11.5C3.25 12.1 3.68 12.58 4.25 12.7V19.5C4.25 20.19 4.81 20.75 5.5 20.75H18.5C19.19 20.75 19.75 20.19 19.75 19.5V12.7C20.32 12.58 20.75 12.1 20.75 11.5V9C20.75 8.31 20.19 7.75 19.5 7.75ZM19.25 11.25H12.75V9.25H19.25V11.25ZM16 4.75C16.69 4.75 17.25 5.31 17.25 6C17.25 6.69 16.69 7.25 16 7.25H12.84C13.18 5.82 14.47 4.75 16 4.75ZM8 4.75C9.53 4.75 10.82 5.82 11.16 7.25H8C7.31 7.25 6.75 6.69 6.75 6C6.75 5.31 7.31 4.75 8 4.75ZM4.75 9.25H11.25V11.25H4.75V9.25ZM5.75 12.75H11.25V19.25H5.75V12.75ZM18.25 19.25H12.75V12.75H18.25V19.25Z" className={[_s.inheritFill].join(' ')} />
  </svg>
)

class ProfileHeader extends ImmutablePureComponent {
  state = {
    stickied: false,
    offset: window.scrollY,
  }

  timeout = null

  handleScroll = () => {
    const offset = window.scrollY
    const { offset: stateOffset } = this.state
    if (offset >= 300 && stateOffset >= 300) return 
    this.setState({ offset });
  }

  componentDidMount() {
    const { account, width } = this.props

    this.checkRelationships(account)
    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    if (isXS) {
      this.handleScroll()
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentDidUpdate(prevProps) {
    const { account } = this.props
    if (prevProps.account !== account) {
      this.checkRelationships(account)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  checkRelationships = (account) => {
    if (!account) return
    if (!account.get('relationship')) {
      this.props.onFetchRelationships(account.get('id'))
    }
  }

  handleOnEditProfile = () => {
    this.props.onEditProfile()
  }

  handleOpenMore = () => {
    const { openProfileOptionsPopover, account } = this.props

    openProfileOptionsPopover({
      account,
      targetRef: this.openMoreNode,
      position: 'left',
    })
  }

  handleToggleShortcut = () => {
    const { account, isShortcut } = this.props
    const accountId = !!account ? account.get('id') : null
    
    if (!accountId) return

    if (isShortcut) {
      this.props.onRemoveShortcut(accountId)
    } else {
      this.props.onAddShortcut(accountId)
    }
  }

  onStickyStateChange = (status) => {
    if (status.status === Sticky.STATUS_FIXED) {
      this.setState({ stickied: true })
    } else {
      this.setState({ stickied: false })
    }
  }

  handleOnCreateChatConversation = () => {
    const { account } = this.props
    const accountId = !!account ? account.get('id') : null
    
    if (!accountId) return

    this.props.onCreateChatConversation(accountId, this.props.history)
  }

  handleOpenGift = () => {
    const { account } = this.props
    const username = !!account ? account.get('acct') : ''

    this.props.onOpenGiftGabPROModal(username)
  }

  setOpenMoreNodeRef = (n) => {
    this.openMoreNode = n
  }
  
  setMobileAvatarContainer = (n) => {
    this.mobileAvatarContainer = n
  }

  render() {
    const {
      account,
      children,
      isShortcut,
      isXS,
      unavailable,
      theme,
      width,
    } = this.props
    const { stickied, offset } = this.state

    if (isXS && !account) {
      return (
        <div className={[_s.d, _s.z1, _s.w100PC].join(' ')}>
          <div className={[_s.d, _s.z1, _s.w100PC, _s.boxShadowBlock, _s.bgPrimary].join(' ')}>
            <div className={[_s.d, _s.w100PC].join(' ')}>
              <ProfileHeaderXSPlaceholder />
            </div>
          </div>
        </div>
      )
    }

    const username = !!account ? account.get('acct') : ''
    // const showGroups = !!account ? (account.getIn(['profile_settings', 'show_group_member'], false) | account.getIn(['profile_settings', 'show_group_admin'], false)) : false
    // const showFeeds = !!account ? (account.getIn(['profile_settings', 'show_feed_subscribed'], false) | account.getIn(['profile_settings', 'show_feed_admin'], false)) : false

    const baseColor = getBaseColor(theme)
    const backgroundImage = `linear-gradient(to top, rgb(${baseColor}), rgba(${baseColor}.9), rgba(${baseColor},.7), rgba(${baseColor},.4), rgba(${baseColor},0))`
    
    const tabs = !account ? null : [
      {
        to: `/${username}`,
        title: 'Timeline',
      },
      {
        to: `/${username}/comments`,
        title: 'Comments',
      },
      {
        to: `/${username}/photos`,
        title: 'Photos',
      },
      {
        to: `/${username}/videos`,
        title: 'Videos',
      },
      {
        to: `/${username}/listings`,
        title: 'Listings',
      },
      // showGroups && {
      //   to: `/${username}/groups`,
      //   title: 'Groups',
      // },
      // showFeeds && {
      //   to: `/${username}/feeds`,
      //   title: 'Feeds',
      // },
    ].filter(Boolean)

    const isMyProfile = !account ? false : account.get('id') === me
    if (isMyProfile) {
      tabs.push({
        to: `/${username}/likes`,
        title: 'Likes',
      })
      tabs.push({
        to: `/${username}/bookmarks`,
        title: 'Bookmarks',
      })
    }

    const isLG = width <= BREAKPOINT_LARGE
    const headerSrc = !!account ? account.get(isXS ? 'header_static' : 'header') : undefined
    const headerMissing = !headerSrc ? true : headerSrc.indexOf(PLACEHOLDER_MISSING_HEADER_SRC) > -1
    const avatarSize = headerMissing ? 75 : 150
    let top = headerMissing ? -46 : -470
    const allowChat = !unavailable
    const nameHTML = !!account ? account.get('display_name_html') : ''
    
    const avatarContainerClasses = CX({
      d: 1,
      circle: 1,
      z5: 1,
      mtNeg75PX: !headerMissing,
      boxShadowProfileAvatar: !headerMissing,
      bgPrimary: 1,
    })

    const stickyBarContainerClasses = CX({
      d: 1,
      flexRow: 1,
      pr15: 1,
      aiCenter: 1,
      displayNone: !stickied,
    })

    const tabBarContainerClasses = CX({
      d: 1,
      displayNone: stickied,
    })

    const mobileDescriptionContainerClasses = CX({
      d: 1,
      w100PC: 1,
      px15: 1,
      mb5: 1,
      pt10: !!me,
    })

    const newState = {
      avatarMarginTop: -40,
      avatarSize: 88,
      headerBlur: 0,
      headerScale: 1,
      headerOpacity: 0,
      navTitleTop: 100,
    }
    if (!headerMissing) {
      if (offset <= 120) {
        // Calculate margin and size based on scroll offset
        newState.avatarMarginTop = Math.max(-40, -40 + (50 * offset) / 120)
        newState.avatarSize = 88 - (48 * offset) / 120
        newState.headerBlur = (5 / 120) * offset
        newState.headerScale = 1 + (0.5 / 120) * offset
      } else {
        newState.avatarMarginTop = 10
        newState.avatarSize = 40
        newState.headerBlur = 5
        newState.headerScale = 1.5
      }
    }
    if (offset >= 100) {
      newState.headerOpacity = Math.min((offset - 100) / 20, 1)
    } else {
      newState.headerOpacity = 0
    }
    if (offset >= 180) {
      newState.navTitleTop = Math.max(100 - (100 / 40) * (offset - 180), 0);
    }

    const desktopAvatarWrapperClasses = CX({
      d: 1,
      flexRow: 1,
      pr10: width <= 1380, // hardcoded, defined in css
      pl10: width <= 1380 && width > BREAKPOINT_MEDIUM, // hardcoded, defined in css
      pl15: width <= BREAKPOINT_MEDIUM,
    })

    const smallAvatarClass = headerMissing ? 88 : Math.min(newState.avatarSize, 88)

    return (
      <div className={[_s.d, _s.z1, _s.w100PC].join(' ')}>
        {
          isXS &&
          <div className={[_s.d, _s.z1, _s.w100PC, _s.aiCenter, _s.boxShadowBlock, _s.bgPrimary].join(' ')}>

            <div className={[_s.d, _s.w100PC].join(' ')}>
              <ProfileNavigationBar
                isSolid={headerMissing}
                account={account}
                theme={theme}
                headerSrc={headerSrc}
                opacity={newState.headerOpacity}
                navTitleTop={newState.navTitleTop}
                titleHTML={nameHTML}
              />

              {
                !headerMissing &&
                <div className={[_s.d, _s.z2, _s.h172PX, _s.w100PC, _s.overflowHidden].join(' ')}>
                  <div
                    className={[_s.d, _s.h172PX, _s.w100PC].join(' ')}
                    style={{
                      filter: `blur(${newState.headerBlur}px) brightness(${1.85 - newState.headerScale})`,
                      transform: `scale(${Math.max(newState.headerScale, 1)})`,
                    }}
                  >
                    <Image
                      alt='Header photo'
                      className={_s.h100PC}
                      cfWidthPX='992px'
                      src={headerSrc}
                      expandOnClick
                    />
                  </div>
                </div>
              }

              {
                headerMissing &&
                <div className={[_s.d, _s.h53PX, _s.w100PC, _s.bgPrimary].join(' ')} />
              }

              <div className={[_s.d, _s.z3, _s.w100PC].join(' ')}>

                <div className={[_s.d, _s.px15].join(' ')}>
                  <div className={[_s.d, _s.flexRow].join(' ')}>
                    <div ref={this.setMobileAvatarContainer} className={[_s.d, _s.circle, _s.boxShadowProfileAvatar, _s.bgPrimary].join(' ')} style={{ marginTop: headerMissing ? '10px' : `${newState.avatarMarginTop}px` }}>
                      <Avatar size={smallAvatarClass} account={account} noHover expandOnClick />
                    </div>
                    {
                      account && account.get('id') === me &&
                      <div className={[_s.d, _s.flexRow, _s.pt10, _s.flexGrow1, _s.h40PX, _s.jcEnd].join(' ')}>
                        <Button
                          isOutline
                          radiusSmall
                          backgroundColor='none'
                          color='brand'
                          className={[_s.jcCenter, _s.aiCenter, _s.h40PX].join(' ')}
                          onClick={this.handleOnEditProfile}
                        >
                          <Text color='inherit' weight='bold' size='medium' className={_s.px5}>
                            Edit profile
                          </Text>
                        </Button>
                      </div>
                    }

                    {
                      account && account.get('id') !== me && !!me &&
                      <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.pt15, _s.flexGrow1, _s.h40PX, _s.jcEnd].join(' ')}>
                        <Button
                          radiusSmall
                          icon={isShortcut ? 'star' : 'star-outline'}
                          iconSize='18px'
                          color='brand'
                          backgroundColor='none'
                          className={[_s.jcCenter, _s.aiCenter, _s.px10, _s.mr10].join(' ')}
                          onClick={this.handleToggleShortcut}
                        />
                        {
                          allowChat &&
                          <div className={[_s.d, _s.flexRow, _s.h40PX].join(' ')}>
                            <Button
                              radiusSmall
                              isOutline
                              icon='chat'
                              iconSize='18px'
                              iconClassName={_s.inheritFill}
                              color='brand'
                              backgroundColor='none'
                              className={[_s.jcCenter, _s.aiCenter, _s.mr10, _s.px10].join(' ')}
                              onClick={this.handleOnCreateChatConversation}
                            />
                          </div>
                        }
                        <div className={[_s.d, _s.flexRow, _s.h40PX].join(' ')}>
                          <AccountActionButton account={account} />
                        </div>
                      </div>
                    }
                  </div>

                  <div className={[_s.d, _s.flexRow, _s.flexNormal, _s.pt10].join(' ')}>
                    <DisplayName
                      account={account}
                      isMultiline
                      isLarge
                      noHover
                    />
                  </div>
                </div>

                <div className={[_s.d, _s.bgPrimary, _s.aiCenter].join(' ')}>
                  <div className={mobileDescriptionContainerClasses}>
                    {children}
                  </div>

                  <div className={[_s.d, _s.mt10, _s.mb10, _s.pt5, _s.w100PC].join(' ')}>
                    <Pills pills={tabs} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        { /** desktop */ }
        {
          !isXS &&
          <Sticky top={top} enabled onStateChange={this.onStickyStateChange}>
            <div className={[_s.d, _s.z1, _s.w100PC, _s.aiCenter, _s.boxShadowBlock, _s.bgPrimary].join(' ')}>

              {
                !headerMissing &&
                <div className={[_s.d, _s.h440PX, _s.overflowHidden, _s.w100PC, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.overflowHidden].join(' ')}>
                  <div className={[_s.d, _s.h440PX, _s.w100PC, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.overflowHidden].join(' ')} style={{ filter: 'blur(25px)', transform: 'scale(1.25)' }}>
                    <Image height='100%' cfWidthPX='1440px' src={headerSrc} />
                  </div>
                  <div
                    className={[_s.d, _s.z2, _s.posAbs, _s.h440PX, _s.top0, _s.left0, _s.right0].join(' ')}
                    style={{ backgroundImage }}
                  />
                </div>
              }
              <div className={[_s.d, _s.w1255PX, _s.z3].join(' ')}>
                {
                  !headerMissing &&
                  <div className={[_s.d, _s.h440PX, _s.w100PC, _s.bottomRightRadiusSmall, _s.bottomLeftRadiusSmall, _s.overflowHidden].join(' ')}>
                    <Image
                      cfWidthPX='1440px'
                      alt='Header photo'
                      className={_s.h100PC}
                      src={headerSrc}
                      expandOnClick
                    />
                  </div>
                }
                {
                  headerMissing &&
                  <div className={[_s.d, _s.h20PX, _s.w100PC].join(' ')} />
                }

                <div className={[_s.d, _s.profileHeaderWidth, _s.mlAuto, _s.mrAuto].join(' ')}>

                  <div className={desktopAvatarWrapperClasses}>
                    <div className={avatarContainerClasses}>
                      {
                        account &&
                        <Avatar size={avatarSize} account={account} noHover expandOnClick />
                      }
                      {
                        !account &&
                        <div
                          className={[_s.d, _s.circle, _s.overflowHidden, _s.bgSecondary].join(' ')}
                          style={{
                            width: `${avatarSize}px`,
                            height: `${avatarSize}px`,
                          }}
                        />
                      }
                    </div>

                    <div className={[_s.d, _s.flexRow, _s.px15, _s.flexNormal, _s.py10].join(' ')}>
                      <DisplayName account={account} isMultiline isReallyLarge noHover />
                    </div>
                  </div>

                  <div className={[_s.d, _s.flexRow, _s.bgPrimary, _s.h53PX].join(' ')}>
                    <div className={tabBarContainerClasses}>
                      <TabBar tabs={tabs} isLarge />
                    </div>

                    <div className={stickyBarContainerClasses}>
                      <Avatar size={40} account={account} noHover />
                      <div className={[_s.d, _s.ml10].join(' ')}>
                        <DisplayName account={account} noUsername noRelationship noHover isLarge />
                      </div>
                    </div>

                    {
                      account && account.get('id') === me &&
                      <div className={[_s.d, _s.flexRow, _s.mlAuto, _s.py5].join(' ')}>
                        <Button
                          radiusSmall
                          isOutline
                          backgroundColor='none'
                          color='brand'
                          className={[_s.jcCenter, _s.aiCenter].join(' ')}
                          onClick={this.handleOnEditProfile}
                        >
                          <Text color='inherit' weight='bold' size='medium' className={_s.px5}>
                            Edit profile
                          </Text>
                        </Button>
                        <Button
                          radiusSmall
                          isOutline
                          icon='search'
                          iconSize='18px'
                          iconClassName={[_s.inheritFill, _s.px2].join(' ')}
                          color='brand'
                          backgroundColor='none'
                          className={[_s.jcCenter, _s.aiCenter, _s.ml10, _s.px10].join(' ')}
                          href='/settings/statuses'
                        />
                      </div>
                    }

                    {
                      account && account.get('id') !== me &&
                      <div className={[_s.d, _s.flexRow, _s.mlAuto, _s.pb2, _s.pt7].join(' ')}>
                        {
                          !!me &&
                          <div className={[_s.d, _s.flexRow, _s.mr5, _s.aiCenter, _s.jcCenter].join(' ')}>
                            <Button
                              radiusSmall
                              icon={isShortcut ? 'star' : 'star-outline'}
                              iconSize='18px'
                              color='brand'
                              backgroundColor='none'
                              className={[_s.jcCenter, _s.aiCenter, _s.px10, _s.mr10].join(' ')}
                              onClick={this.handleToggleShortcut}
                            />
                            <Button
                              radiusSmall
                              isOutline
                              title='Gift GabPRO'
                              color='brand'
                              backgroundColor='none'
                              className={[_s.jcCenter, _s.aiCenter, _s.fillWhite_onHover, _s.fillBrand, _s.mr15, _s.h40PX, _s.w40PX, _s.px2, _s.py2].join(' ')}
                              onClick={this.handleOpenGift}
                            >
                              {giftIcon}
                            </Button>
                            <Button
                              radiusSmall
                              isOutline
                              icon='ellipsis'
                              title='More options'
                              iconSize='18px'
                              iconClassName={_s.inheritFill}
                              color='brand'
                              backgroundColor='none'
                              className={[_s.jcCenter, _s.aiCenter, _s.mr15, _s.px10].join(' ')}
                              onClick={this.handleOpenMore}
                              buttonRef={this.setOpenMoreNodeRef}
                            />
                            {
                              allowChat &&
                              <Button
                                radiusSmall
                                isOutline
                                icon='chat'
                                iconSize='18px'
                                iconClassName={_s.inheritFill}
                                color='brand'
                                backgroundColor='none'
                                className={[_s.jcCenter, _s.aiCenter, _s.mr10, _s.px10].join(' ')}
                                onClick={this.handleOnCreateChatConversation}
                              />
                            }
                          </div>
                        }

                        <div className={[_s.d, _s.flexRow, _s.pb2].join(' ')}>
                          <AccountActionButton account={account} />
                        </div>

                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Sticky>
        }
      </div>
    )
  }

}

const mapStateToProps = (state, { account }) => {
  const accountId = account ? account.get('id') : null
  const shortcuts = state.getIn(['shortcuts', 'items'])
  const isShortcut = !!shortcuts.find((s) => {
    return `${s.get('shortcut_id')}` === `${accountId}` && s.get('shortcut_type') === 'account'
  })

  const isBlocked = state.getIn(['relationships', accountId, 'blocked_by'], false)
  const isLocked = state.getIn(['accounts', accountId, 'locked'], false)
  const isFollowing = state.getIn(['relationships', accountId, 'following'], false)

  const unavailable = (me === accountId) ? false : (isBlocked || (isLocked && !isFollowing))

  return {
    isShortcut,
    unavailable,
    theme: state.getIn(['settings', 'displayOptions', 'theme']),
    width: state.getIn(['settings', 'window_dimensions', 'width']),
  }
}

const mapDispatchToProps = (dispatch) => ({
  openProfileOptionsPopover(props) {
    dispatch(openPopover(POPOVER_PROFILE_OPTIONS, props))
  },
  onEditProfile() {
    dispatch(openModal(MODAL_EDIT_PROFILE))
  },
  onAddShortcut(accountId) {
    dispatch(addShortcut('account', accountId))
  },
  onRemoveShortcut(accountId) {
    dispatch(removeShortcut(null, 'account', accountId))
  },
  onCreateChatConversation(accountId, routerHistory) {
    dispatch(createChatConversation(accountId, routerHistory))
  },
  onFetchRelationships(accountId) {
    dispatch(fetchRelationships([accountId]))
  },
  onOpenGiftGabPROModal(username) {
    dispatch(openModal(MODAL_GIFT_GAB_PRO, { username }))
  },
});

ProfileHeader.propTypes = {
  account: ImmutablePropTypes.map,
  children: PropTypes.any,
  onAddShortcut: PropTypes.func.isRequired,
  onEditProfile: PropTypes.func.isRequired,
  onRemoveShortcut: PropTypes.func.isRequired,
  openProfileOptionsPopover: PropTypes.func.isRequired,
  isShortcut: PropTypes.bool.isRequired,
  isXS: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileHeader))
